import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import api from "../apiClient";

import { IUsernamePassword } from "../../interfaces/services";

import cookiesHelper from "../../helpers/cookies";

export interface IPayload {
    creds: IUsernamePassword;
    setApiError: Function;
    setIsProcessing: Function;
};

const useSignIn = () => {
    const navigate = useNavigate();

    const mutationFn = async (data: IPayload) => {
        const res = await api.get(`admins/sign-in?username=${data.creds.username}&password=${data.creds.password}`);
        return res.data;
    };

    return useMutation({
        mutationFn,
        onSuccess: (response: any, variables: IPayload) => {
            if (response) {
                cookiesHelper.setCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string, response, (60 * 60 * 1000));
                navigate("/", { replace: true });
            };
        },
        onError: (error: any, variables: IPayload) => {
            variables.setApiError(error?.response?.data?.message ?? "An error occurred. Please try again.");
        },
        onSettled: (data: any, error: any, variables: IPayload) => {
            variables.setIsProcessing(false);
        },
    });
};

export default useSignIn;